// PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabaseAnon } from "../db.js"; // adjust path as needed

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/get-session`, {
          method: "GET",
          credentials: "include", // must include cookies
          headers: { Accept: "application/json" },
        });

        if (!mounted) return;

        if (res.ok) {
          const json = await res.json();

          // Set the user body in the local storage
          localStorage.setItem("sb_id", JSON.stringify(json.user));

          setSession(json.user ?? true);
        } else {
          setSession(null);
        }
      } catch (err) {
        console.error("verify fetch error", err);
        setSession(null);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    check();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return <div>Loading...</div>; // show a spinner or placeholder

  // 4. If logged in, render children. Otherwise, redirect to landing
  return session ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
